import firebaseApp from "../firebase";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  section: {
    async getAll() {
      const querySnapshot = await getDocs(collection(db, "sections"));

      return querySnapshot.docs
        .map((doc) => doc.data())
        .sort((a, b) => a.code - b.code);
    },
    async get(code) {
      const q = query(collection(db, "sections"), where("code", "==", code));
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.length ? querySnapshot.docs[0].data() : null;
    },
  },
  chapter: {
    async getAll(sectionCode) {
      const q = query(
        collection(db, "chapters"),
        where("section", "==", sectionCode)
      );
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs
        .map((doc) => doc.data())
        .sort((a, b) => a.code - b.code);
    },
    async get(code) {
      const q = query(collection(db, "chapters"), where("code", "==", code));
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.length ? querySnapshot.docs[0].data() : null;
    },
  },
  code: {
    async getAll(chapterCode) {
      const q = query(
        collection(db, "codes"),
        where("chapter", "==", chapterCode)
      );
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs
        .map((doc) => doc.data())
        .sort((a, b) => a.code - b.code);
    },
    async get(code) {
      const q = query(collection(db, "codes"), where("code", "==", code));
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.length ? querySnapshot.docs[0].data() : null;
    },
  },
};
